import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getClient } from '@sakura-grp/database';
import { useAuthStore } from '@/stores/auth';

/**
 * サインアウトページ
 *
 * アクセスすると自動的にサインアウト処理を実行し、
 * サインインページへリダイレクトします。
 */
export default function SignOut() {
  const navigate = useNavigate();
  const { signOut: signOutStore } = useAuthStore();
  const supabase = getClient();

  useEffect(() => {
    const handleSignOut = async () => {
      console.log('[SignOut] サインアウト開始');

      try {
        // Supabaseからサインアウト
        const { error } = await supabase.auth.signOut();

        if (error) {
          console.error('[SignOut] Supabaseサインアウトエラー:', error);
        } else {
          console.log('[SignOut] Supabaseサインアウト成功');
        }

        // Zustand storeをクリア
        signOutStore();
        console.log('[SignOut] ストアクリア完了');

        // サインインページへリダイレクト
        navigate('/sign-in', { replace: true });
        console.log('[SignOut] サインインページへリダイレクト');
      } catch (err) {
        console.error('[SignOut] 予期しないエラー:', err);
        // エラーが発生してもサインインページへリダイレクト
        navigate('/sign-in', { replace: true });
      }
    };

    handleSignOut();
  }, [navigate, signOutStore, supabase]);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <div className="mb-4 text-lg">サインアウト中...</div>
      </div>
    </div>
  );
}
